import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { filter, finalize, first, take, takeUntil, tap } from 'rxjs/operators';
import { MembershipStatusDto, UserDto } from 'src/app/api/models';
import { Observable, timer } from 'rxjs';
import { MembershipService } from '../../services/membership/membership.service';

@Injectable({
  providedIn: 'root'
})
export class ProcessingResolver  {
  membershipStatus = MembershipStatusDto;
  user$: Observable<UserDto>
  constructor(
    private userService: UserService,
    private membershipService: MembershipService,
    private router: Router
  ) {
    this.user$ = this.userService.user$
  }

  resolve(route: ActivatedRouteSnapshot) {
    return timer(600, 950).pipe(
      tap(() => this.fetchUserData()),
      takeUntil(this.user$.pipe(filter(u => u?.subscription.status === this.membershipStatus.Active))),
      take(20),
      finalize(() => {
        const isReactivation = sessionStorage.getItem('checkoutIntent') === 'reactivation';
        sessionStorage.removeItem('checkoutIntent');

        setTimeout(() => {
          return this.router.navigate([isReactivation ? '/' : '/thank-you']);
        }, 200);
      })
    ).subscribe()
  }

  fetchUserData() {
    this.userService.fetchUser().pipe(first()).subscribe();
    this.membershipService.fetchMembership().then();
  }

}